export default __webpack_public_path__ + "static/media/GR00015-sciences_card_2.e54e870b.svg";